var _g, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpendingOnboardingAgentCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 98,
    height: 76,
    viewBox: "0 0 98 76",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_2355_45091)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.5962,
    y: 12.0607,
    width: 64,
    height: 40,
    rx: 6,
    transform: "rotate(-4 15.5962 12.0607)",
    fill: "#000D26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.151 18.2214L25.3765 18.9049L25.9345 26.8847C27.579 26.7697 29.0601 27.676 29.7631 29.066C30.0435 29.6203 30.6316 29.9475 31.2485 29.9044C31.8656 29.8612 32.4024 29.4553 32.6029 28.8674C33.1056 27.3931 34.4462 26.2895 36.0907 26.1745C38.2837 26.0212 40.1863 27.6837 40.3404 29.8878C40.4946 32.0919 38.8418 34.0031 36.6489 34.1564C35.0043 34.2714 33.5232 33.3651 32.8202 31.9752C32.5398 31.4208 31.9518 31.0936 31.3347 31.1367C30.7177 31.1799 30.1809 31.5858 29.9804 32.1737C29.4777 33.648 28.1372 34.7516 26.4926 34.8666L27.0506 42.8464L36.8252 42.1629C43.4029 41.703 48.3604 35.9706 47.8981 29.3593C47.4358 22.748 41.7287 17.7614 35.151 18.2214Z",
    fill: "url(#paint0_radial_2355_45091)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.151 18.2214L25.3765 18.9049L25.9345 26.8847C27.579 26.7697 29.0601 27.676 29.7631 29.066C30.0435 29.6203 30.6316 29.9475 31.2485 29.9044C31.8656 29.8612 32.4024 29.4553 32.6029 28.8674C33.1056 27.3931 34.4462 26.2895 36.0907 26.1745C38.2837 26.0212 40.1863 27.6837 40.3404 29.8878C40.4946 32.0919 38.8418 34.0031 36.6489 34.1564C35.0043 34.2714 33.5232 33.3651 32.8202 31.9752C32.5398 31.4208 31.9518 31.0936 31.3347 31.1367C30.7177 31.1799 30.1809 31.5858 29.9804 32.1737C29.4777 33.648 28.1372 34.7516 26.4926 34.8666L27.0506 42.8464L36.8252 42.1629C43.4029 41.703 48.3604 35.9706 47.8981 29.3593C47.4358 22.748 41.7287 17.7614 35.151 18.2214Z",
    fill: "url(#paint1_radial_2355_45091)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 61.7124,
    y: 22.5186,
    width: 12,
    height: 12,
    rx: 2,
    transform: "rotate(-4 61.7124 22.5186)",
    fill: "#E8C284"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_2355_45091",
    x: 0,
    y: 0,
    width: 97.8267,
    height: 75.5596,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.0509804 0 0 0 0 0.14902 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2355_45091"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0235294 0 0 0 0 0.0862745 0 0 0 0 0.211765 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_2355_45091",
    result: "effect2_dropShadow_2355_45091"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_2355_45091",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_2355_45091",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(16.0518 19.5947 -17.7449 14.5763 27.7339 21.0123)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD601"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.589342,
    stopColor: "#F7A1B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#97D5FC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_2355_45091",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(0.372034 5.32034 -5.3718 0.383194 36.5389 31.3566)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.245192,
    stopColor: "#000D26",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000D26",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpendingOnboardingAgentCard);
export default __webpack_public_path__ + "static/media/spending-onboarding-agent-card.d1be05a8641b0bc89659643e41273212.svg";
export { ForwardRef as ReactComponent };